import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastPortal from '../toastify/ToastPortal';

const GlobalAlert = () => {
  return (
    <ToastPortal>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        zindex={9999}
      />
    </ToastPortal>
  );
};

export default GlobalAlert;
